export default function useFormHooks () {
    const headerNonce = ()=>document?.getElementsByName('header-nonce')?.[0]?.getAttribute('content');
    const POST = async (url, data) => {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': headerNonce()
                },
                body: JSON.stringify(data)
            })
            return response.json()
        } catch (error) {
            console.error('Error submitting form:', error)
        }
        // return await data
    }
    const GET = async url => { 
        try {
            const response = await fetch(url)
            return response.json()
        } catch (error) {
            console.error('Error submitting form:', error)
        }
    }

    return { POST, GET }
}